"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeNulls = void 0;
var removeNulls = function (obj) {
  if (obj === null || typeof obj === 'string' && obj === '') {
    return undefined;
  }
  if (typeof obj === 'object') {
    for (var key in obj) {
      obj[key] = (0, exports.removeNulls)(obj[key]);
    }
  }
  return obj;
};
exports.removeNulls = removeNulls;